import { render } from "./HelpCategoriesDropdown.vue?vue&type=template&id=f1f45c48&ts=true"
import script from "./HelpCategoriesDropdown.vue?vue&type=script&lang=ts"
export * from "./HelpCategoriesDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__